import { Canvas } from 'canvas';
import type { Canvas as SkiaCanvas, createCanvas as createSkiaCanvas } from '@napi-rs/canvas';

export default function createCanvas(width: number, height: number): HTMLCanvasElement | Canvas | SkiaCanvas {
  if(IS_BROWSER) {
    return Object.assign(document.createElement('canvas'), { width, height })
  } else {
    if(global.renderEngine === 'cairo') {
      return new Canvas(width, height)
    } else {
      //Default to skia
      // Webpack removes this branch from browser builds via IS_BROWSER.
      // eslint-disable-next-line @typescript-eslint/no-require-imports
      const skiaCanvas = require('@napi-rs/canvas') as { createCanvas: typeof createSkiaCanvas }
      return skiaCanvas.createCanvas(width > 0 ? width : 1, height > 0 ? height : 1)
    }
  }
}
